const initScroll = (container, content) => {
  const api = container.jScrollPane().data('jsp');
  if (content.height() > container.height()) {
    container.jScrollPane({
      contentWidth : 0,
      showArrows: false,
      horizontalDragMinWidth: 2,
      horizontalDragMaxWidth: 2
    });
  } else {
    api.reinitialise();
  }
};
const reinitResizeScroll = (block) => {
  const api = block.jScrollPane().data('jsp');
  api.reinitialise();
};
const collection = {
  collFirstItemLink : $('.js-collection-first-link'),
  collContainerInner : $('.js-collection-inner'),

  secondColl : $('.js-collection-second'),
  secondCollLink : $('.js-collection-second-link'),
  innerCollContent : $('.js-collection-second-content'),
  innerCollList : $('.js-collection-second-list'),
  buttonSecondPrev : $('.js-collection-second-prev'),
  buttonSecondTitleLink: $('.js-collection-second-prev-titleLink'),

  threeColl : $('.js-collection-three'),
  threeCollContent : $('.js-collection-three-content'),
  threeCollList : $('.js-collection-three-inner-content'),
  threePrevButton : $('.js-collection-three-prev'),
  threePrevTitleLink: $('.js-collection-three-prev-titleLink'),
  showSecondList (id, scroll) {
    this.collContainerInner.addClass('current');
    this.secondColl.addClass('current');

    this.innerCollList.removeClass('current');
    $(`.js-collection-second-list[data-id="${id}"]`).addClass('current');

    if(scroll) {
      initScroll(this.innerCollContent, $(`.js-collection-second-list[data-id="${id}"]`));
    }
  },
  hideSecondList() {
    this.collContainerInner.removeClass('current');
    this.secondColl.removeClass('current');
    this.innerCollList.removeClass('current');
  },
  showThreeList(id, scroll) {
    this.threeColl.addClass('current');
    this.threeCollList.removeClass('current');
    this.threeColl.find(`.js-collection-three-inner-content[data-id="${id}"]`).addClass('current');

    if(scroll) {
      initScroll(this.threeCollContent, $(`.js-collection-three-inner-content[data-id="${id}"]`));
    }
  },
  hideThreeList() {
    this.threeColl.removeClass('current');
    this.threeCollList.removeClass('current');
  },
}
if($(window).width() < 1200) {
  $(document).on('click', '.js-collection-first-link', function(e) {
    e.preventDefault();
    const $this = $(this),
          href = $this.attr('href'),
          text = $this.text();
    if($(window).width() <= 767) {
      collection.buttonSecondTitleLink.text(text).attr('href', href);
      collection.showSecondList($(this).data('id'), true);
    } else {
      collection.hideSecondList();
      collection.hideThreeList();

      if($this.hasClass('current')) {
        $this.removeClass('current');
      } else {
        $('.js-collection-first-link').removeClass('current');
        $this.addClass('current');
        collection.buttonSecondTitleLink.text(text).attr('href', href);
        collection.showSecondList($(this).data('id'), true);
      }
    }
  });

  $(document).on('click', '.js-collection-second-prev', function() {
    collection.hideSecondList();
  });

  $(window).resize(function() {
    reinitResizeScroll(collection.innerCollContent);
  });

  $(document).on('click', '.js-collection-second-link', function(e) {
    e.preventDefault();
    const $this = $(this),
          href = $this.attr('href'),
          text = $this.text();
    collection.threePrevTitleLink.text(text).attr('href', href);
    collection.showThreeList($this.data('id'), true);
  });

  $(document).on('click', '.js-collection-three-prev', function() {
    collection.hideThreeList();
  });

  $(document).on('click', function(e) {
    if ($(e.target).closest('.collection').length === 0) {
      collection.hideSecondList();
      collection.hideThreeList();
      $('.js-collection-first-link').removeClass('current');
    }
  })
}

$('.js-catalog-menu-toggle').hover(function() {
  $('.js-catalog-coll').fadeIn(function() { $(this).stop()});
}, function(e) {
  if(!$(e.relatedTarget).hasClass('catalogCollection__link')){
    $('.js-catalog-coll').fadeOut(function() { $(this).stop()});
  }
});

$(document).on('click', '.js-collection-toggle', function() {
  if($('.js-collection-catalog').hasClass('collection__catalog--hidden')) {
    if($('.js-collection-catalog').is(':hidden')) {
      $('.js-collection-catalog').fadeIn(function() { $(this).stop()});
      if ($(window).width() < 768) {
        $('body').addClass('hidden-overflow');
      }
    } else {
      $('.js-collection-catalog').fadeOut(function() { $(this).stop()});
      $('body').removeClass('hidden-overflow');
    }
  }
});

$(document).on('click', function (e) {
  if (!$(e.target).closest('.collection').length) {
    $('.js-collection-catalog').fadeOut(function () { $(this).stop() });
    $('body').removeClass('hidden-overflow');
  }
});